import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from '@mui/material';
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

const messages = defineMessages({
  saveGroupsRequired: {
    id: 'autoCuration.pdfSplitEditor.saveGroupsRequired',
    defaultMessage: 'Save Groups Required',
  },
  savePageGroups: {
    id: 'autoCuration.pdfSplitEditor.savePageGroups',
    defaultMessage:
      'Please save your page groups before starting auto curation. Click the Save button to save your groups, then you can start the auto curation process.',
  },
  ok: {
    id: 'autoCuration.pdfSplitEditor.ok',
    defaultMessage: 'OK',
  },
});
interface SaveGroupsPromptDialogProps {
  open: boolean;
  onClose: () => void;
}

/**
 * Dialog to prompt user to save groups before starting auto curation
 */
export const SaveGroupsPromptDialog = ({
  onClose,
  open,
}: SaveGroupsPromptDialogProps) => {
  const { formatMessage } = useIntl();
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="save-dialog-title"
      aria-describedby="save-dialog-description"
    >
      <DialogTitle id="save-dialog-title">
        {formatMessage(messages.saveGroupsRequired)}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="save-dialog-description">
          {formatMessage(messages.savePageGroups)}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          {formatMessage(messages.ok)}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
